import React, { useCallback, useEffect, useState } from 'react';
export const ImageLoadingComponent = ({
  onClick,
  onLoad,
  onRegisterLinkOpen,
  onRegister,
  src,
  alt,
  className
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    onRegister();
    return () => {
      if (!isLoaded) {
        onLoad();
      }
    };
  }, []);
  useEffect(() => {
    if (isLoaded) {
      onLoad();
    }
  }, [isLoaded, onLoad]);
  const handleLoad = useCallback(() => {
    setIsLoaded(true);
    onRegisterLinkOpen();
  }, [onRegisterLinkOpen]);
  const handleError = () => {
    setIsLoaded(true);
  };
  return /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: alt,
    className: className,
    onClick: onClick && onClick,
    onLoad: handleLoad,
    onError: handleError
  });
};